import {useEffect} from 'react';
import classNames from 'classnames';
import CustomButton from '../../../components/customButton';
import Activities from '../../../module/shop/lab/activities';
import styles from './selectCertificates.module.scss';

import {useState} from 'react';
import {LabCertificates} from '../../shop/create/lab/helper/data';
import {useLab} from '../../../context/labContext';
import {useNavigate} from 'react-router-dom';
import UseUpdateLabShop from '../hooks/useUpdateLabShop';
import Header from '../../../components/header';
import {payloadConvertor} from './helper/payloadConvertor';

const SelectCertificates = () => {
  const [selectedLabCertificate, setSelectedLabCertificate] = useState<
    Array<ILabCertificate>
  >([]);
  const {updateLab, isLoading} = UseUpdateLabShop();

  const {lab} = useLab();

  const handleClick = () => {
    updateLab(payloadConvertor({lab, selectedLabCertificate}));
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!lab) {
      navigate('/lab/manage');
    }
  }, [lab, navigate]);

  useEffect(() => {
    setSelectedLabCertificate(
      LabCertificates.filter(item => lab?.certificate?.includes(item.id)),
    );
  }, [lab]);

  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />
      <div
        className={classNames('d-flex flex-column', styles['select-activity'])}
      >
        <div className="flex-grow-1">
          <div className="text-center pt-5">
            <h6 className="color-gray-1">
              گواهینامه‌ها و اعتبارنامه‌های کسب شده
            </h6>
          </div>
          <div className="mt-4 px-3">
            <Activities
              selectedLab={selectedLabCertificate}
              setSelectedLab={setSelectedLabCertificate}
              data={LabCertificates}
            />
          </div>
        </div>
        <div className="px-3">
          <CustomButton
            disabled={selectedLabCertificate.length === 0}
            onClick={handleClick}
            isLoading={isLoading}
          >
            ثبت آزمایشگاه
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default SelectCertificates;
